export default __webpack_public_path__ + "static/media/left_shrubs.71522d26.svg";